import {NotificationStatusCode} from "./NotificationStatusCode";
import {CommunicationType} from "./CommunicationType";

export class NotificationData{

  id: number;
  phone: string;
  email: string;
  sentDt: Date;
  senderId: string;
  message: string;
  status: NotificationStatusCode;
  employeeId: string;
  divisionId: string;
  communicationType: CommunicationType;
  externalSystemResp: string;
  externalSystemId: string;


  _createSpecialElement(propertyName: string, data: any) {
    if ('status' === propertyName) {
      this.status = NotificationStatusCode.retrieveFromCode(data);
      return true;
    }
    if ('communicationType' === propertyName) {
      this.communicationType = CommunicationType.retrieveFromCode(data);
      return true;
    }
  }


}
